import { useState } from 'react';
import { SendCompModal } from './SendCompModal';

interface Customer {
  address: string;
  display_name: string | null;
  last_visit_at: string;
}

interface Props {
  atRisk: Customer[];
  // tier comes through so the Send Free Coffee button can be enabled for
  // founding/pro shops only. Free shops see a disabled button with a tooltip.
  tier?: 'free' | 'founding' | 'pro';
  shopId?: string;
  authToken?: string | null;
}

function daysSince(iso: string) {
  return Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
}

export default function AtRiskList({ atRisk, tier, shopId, authToken }: Props) {
  const [target, setTarget] = useState<null | { address: string; name?: string | null }>(null);
  const canSend = (tier === 'founding' || tier === 'pro') && !!shopId && !!authToken;

  return (
    <div className="bg-white rounded-[10px] p-[18px]">
      <p className="font-heading text-[9px] text-body-grey mb-3.5">AT-RISK</p>
      {atRisk.length === 0 ? (
        <p className="font-grotesk text-[13px] text-body-grey">Nobody's drifted away. Nice work.</p>
      ) : (
        <ul className="flex flex-col gap-3">
          {atRisk.map(c => (
            <li key={c.address} className="flex items-center justify-between gap-3">
              <div className="min-w-0">
                <p className="font-grotesk font-bold text-[15px] text-primary truncate">
                  {c.display_name || 'Customer'}
                </p>
                <p className="font-grotesk font-medium text-[13px] text-[#a8a29e]">{daysSince(c.last_visit_at)} days away</p>
              </div>
              {canSend ? (
                <button
                  type="button"
                  onClick={() => setTarget({ address: c.address, name: c.display_name })}
                  className="flex-none rounded-full bg-accent-alt text-gold-ink font-grotesk font-bold text-[13px] py-[11px] px-4"
                >
                  Free coffee
                </button>
              ) : (
                <button
                  disabled
                  title={tier === 'free' ? 'Upgrade to Founding or Pro to send free coffees' : 'Loading…'}
                  className="flex-none rounded-full bg-accent-alt text-gold-ink font-grotesk font-bold text-[13px] py-[11px] px-4 opacity-40 cursor-not-allowed"
                >
                  Free coffee
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
      {target && shopId && authToken && (
        <SendCompModal
          shopId={shopId}
          customerAddress={target.address}
          customerName={target.name}
          authToken={authToken}
          onClose={() => setTarget(null)}
        />
      )}
    </div>
  );
}
